import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import { BACKEND_URL } from '../app.config';
import { Reminder } from '../api/data-model';

@Injectable()
export class ReminderService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  get(entityType: number, entityId: string, subEntityType: number, subEntityId: string): Observable<Reminder> {
    return this.http.get<Reminder>(`${this.baseUrl}/api/app/reminder/details`, {
      params: {
        entityType: entityType,
        entityId: entityId,
        subEntityType: subEntityType,
        subEntityId: subEntityId,
      },
    });
  }

  addReminder(reminder: Reminder): Observable<Reminder> {
    return this.http.post<Reminder>(`${this.baseUrl}/api/app/reminder`, reminder);
  }

  updateReminder(reminder: Reminder): Observable<Reminder> {
    return this.http.put<Reminder>(`${this.baseUrl}/api/app/reminder/${reminder.id}`, reminder);
  }

  updateReminderStatus(id: string, status: number): Observable<Reminder> {
    return this.http.put<Reminder>(`${this.baseUrl}/api/app/reminder/${id}/status`, {
      status: status
    });
  }

  getList(sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<Reminder>> {
      return this.http.get<ListResult<Reminder>>(this.baseUrl + '/api/app/reminder', {
        params: {
          sorting,
          skipCount,
          maxResultCount,
        },
      });
    }
}
